export const CAMPAIGN_ROUTES = {
  info: '/services/promotion-center/info'
} as const;

export const CAMPAIGN_PAGE_SIZE = 10;
